import RoleRepositoryInterface, {
  ApiCreateRoleInterface,
  ApiEditRoleInterface,
  RoleInterface,
} from '@/services/Roles/Interfaces';

import { AxiosInstance } from 'axios';

export enum Roles {
  USER_USERS_CREATE = 'users:users:create',
  USER_USERS_READ = 'users:users:read',
  USER_USERS_EDIT = 'users:users:update',

  USER_SCOPES_SYNC = 'users:scopes:sync',

  USER_ROLES_CREATE = 'users:roles:create',
  USER_ROLES_READ = 'users:roles:read',
  USER_ROLES_UPDATE = 'users:roles:read',

  USER_DEPARTMENTS_READ = 'users:departments:read',
  USER_DEPARTMENTS_CREATE = 'users:departments:create',
  USER_DEPARTMENTS_UPDATE = 'users:departments:update',

  IPSET_IPSET_CREATE = 'ipset:ipset:create',
  IPSET_IPSET_READ = 'ipset:ipset:read',

  VHOST_VHOST_READ = 'vhost:vhost:read',
  VHOST_VHOST_CREATE = 'vhost:vhost:create',

  SERVER_SERVER_READ = 'server:server:read',
  SERVER_SERVER_CREATE = 'server:server:create',

  SMS_SMS_READ = 'sms:sms:read',
  SMS_SMS_CREATE = 'sms:sms:create',

  DNS_ZONE_READ = 'dns:zone:read',
  DNS_ZONE_CREATE = 'dns:zone:create',
  DNS_DEPARTMENT = 'dns:department',

  SSL_CERT_READ = 'ssl:cert:read',
  SSL_CERT_CREATE = 'ssl:cert:create',
  SSL_CERT_DELETE = 'ssl:cert:delete',

  QA_CHAT_READ = 'qa:chat:read',
  QA_CHAT_REVIEW = 'qa:chat:review',
  QA_TICKET_READ = 'qa:ticket:read',
  QA_TICKET_REVIEW = 'qa:ticket:review',
  QA_TAG_READ = 'qa:tag:read',
  QA_TAG_CREATE = 'qa:tag:create',
  QA_TAG_UPDATE = 'qa:tag:update',
  QA_SCORE_TYPE_CREATE = 'qa:score:type:create',
  QA_SCORE_TYPE_UPDATE = 'qa:score:type:update',
  QA_SCORE_TYPE_READ = 'qa:score:type:read',
  QA_SCORE_GRADE_CREATE = 'qa:score:grade:create',
  QA_SCORE_GRADE_UPDATE = 'qa:score:grade:update',
  QA_SCORE_GRADE_READ = 'qa:score:grade:read',
  QA_ESCALATION_READ = 'qa:escalation:read',
  QA_FEEDBACK_READ = 'qa:feedback:read',
  QA_STATISTICS_READ = 'qa:statistic:read',
  QA_MANAGER = 'qa:manager',
  QA_DOSSIER_COMMENT_CREATE = 'dossier:comment:create',
  QA_DOSSIER_COMMENT_READ = 'dossier:comment:read',
  QA_CHAT_QUEUE_SETTINGS = 'qa:chat:settings',

  CALENDAR_SHIFTS_READ = 'calendar:shifts:read',
  CALENDAR_SHIFTS_CREATE = 'calendar:shifts:create',
  CALENDAR_SHIFTS_UPDATE = 'calendar:shifts:update',
  CALENDAR_SHIFTS_DELETE = 'calendar:shifts:delete',
  CALENDAR_EVENTS_READ = 'calendar:events:read',
  CALENDAR_EVENTS_CREATE = 'calendar:events:create',
  CALENDAR_EVENTS_UPDATE = 'calendar:events:update',
  CALENDAR_EVENTS_DELETE = 'calendar:events:delete',
  CALENDAR_LEAVE_CREATE = 'calendar:leave:create',
  CALENDAR_DEFAULT_APPROVERS = 'calendar:request:approvers',
  CALENDAR_EMPLOYEE_UPDATE = 'calendar:employee:update',

  IFM_BROWSE = 'internal-file-manager:files:read',

  BUG_REPORT_READ = 'bug-report:bug-report:read',
  BUG_REPORT_CREATE = 'bug-report:bug-report:create',
  BUG_REPORT_UPDATE = 'bug-report:bug-report:update',
  BUG_REPORT_DELETE = 'bug-report:bug-report:delete',

  BUG_REPORT_SETTINGS = 'bug-report:settings:read',
  BUG_REPORT_ARCHIVE_READ = 'bug-report:archive:read',

  FEATURE_REQUEST_READ = 'feature-request:feature-request:read',
  FEATURE_REQUEST_CREATE = 'feature-request:feature-request:create',
  FEATURE_REQUEST_UPDATE = 'feature-request:feature-request:update',
  FEATURE_REQUEST_DELETE = 'feature-request:feature-request:delete',

  DATABASE_DATABASE_READ = 'database:database:create',
  DATABASE_DATABASE_CREATE = 'database:database:create',
  DATABASE_DATABASE_DELETE = 'database:database:delete',
  DATABASE_USER_READ = 'database:database:read',
  DATABASE_USER_CREATE = 'database:database:create',
  DATABASE_USER_UPDATE = 'database:database:update',
  DATABASE_USER_DELETE = 'database:database:delete',

  SYSTEM_USER_READ = 'system-user:user:read',
  SYSTEM_USER_CREATE = 'system-user:user:create',
  SYSTEM_USER_UPDATE = 'system-user:user:update',
  SYSTEM_USER_DELETE = 'system-user:user:delete',
  SYSTEM_USER_PLAN_READ = 'system-user:plan:read',
  SYSTEM_USER_PLAN_CREATE = 'system-user:plan:create',
  SYSTEM_USER_PLAN_UPDATE = 'system-user:plan:update',
  SYSTEM_USER_PLAN_DELET = 'system-user:plan:delete',

  DOSSIER_USER_READ = 'dossier:user:read',
  DOSSIER_USER_CREATE = 'dossier:user:create',
  DOSSIER_USER_UPDATE = 'dossier:user:update',
  DOSSIER_TEAM_READ = 'dossier:team:read',
  DOSSIER_TEAM_CREATE = 'dossier:team:create',
  DOSSIER_FEEDBACK_CREATE = 'dossier:feedback:create',
  DOSSIER_FEEDBACK_READ = 'dossier:feedback:read',
  DOSSIER_FEEDBACK_UPDATE = 'dossier:feedback:update',

  SCRUM_AUDITS_READ = 'scrums:audits:read',
  SCRUM_AUDITS_CREATE = 'scrums:audits:create',
  SCRUM_AUDITS_UPDATE = 'scrums:audits:update',
  SCRUM_AUDITS_DELETE = 'scrums:audits:delete',

  SCRUM_COMPONENTS_READ = 'scrums:components:read',
  SCRUM_COMPONENTS_CREATE = 'scrums:components:create',
  SCRUM_COMPONENTS_UPDATE = 'scrums:components:update',
  SCRUM_COMPONENTS_DELETE = 'scrums:components:delete',

  WEBSITE_WEBSITE_READ = 'website:website:read',
  WEBSITE_WEBSITE_CREATE = 'website:website:create',
  SCRUM_SETTINGS_CREATE = 'scrums:components:create',

  MAILBOX_MAILBOX_READ = 'mailbox:mailbox:read',
  MAILBOX_MAILBOX_CREATE = 'mailbox:mailbox:create',

  FTP_USER_FTP_USER_READ = 'ftp-user:ftp-user:read',
  FTP_USER_FTP_USER_CREATE = 'ftp-user:ftp-user:create',

  ACTION_LOGS_READ = 'logs:logs:read',

  BACKUP_SERVER_READ = 'backup:server:read',
  BACKUP_SERVER_CREATE = 'backup:server:create',
  BACKUP_SERVER_UPDATE = 'backup:server:update',
  BACKUP_SERVER_DELETE = 'backup:server:delete',

  BACKUP_REPO_READ = 'backup:repo:read',
  BACKUP_REPO_CREATE = 'backup:repo:create',
  BACKUP_REPO_UPDATE = 'backup:repo:update',
  BACKUP_REPO_DELETE = 'backup:repo:delete',
  BACKUP_REPO_LOCK = 'backup:repo:lock',

  BACKUP_REPO_PRUNE = 'backup:repo:prune',
  BACKUP_REPO_FORGET = 'backup:repo:forget',

  BACKUP_BACKUP_READ = 'backup:backup:read',
  BACKUP_BACKUP_CREATE = 'backup:backup:create',
  BACKUP_BACKUP_UPDATE = 'backup:backup:update',
  BACKUP_BACKUP_RESTORE = 'backup:restore:create',
  BACKUP_BACKUP_DELETE = 'backup:backup:delete',

  BACKUP_SCHEDULE_READ = 'backup:schedule:read',
  BACKUP_SCHEDULE_CREATE = 'backup:schedule:create',
  BACKUP_SCHEDULE_UPDATE = 'backup:schedule:update',
  BACKUP_SCHEDULE_DELETE = 'backup:schedule:delete',

  BACKUP_TASK_READ = 'backup:task:read',
  BACKUP_TASK_CREATE = 'backup:task:create',
  BACKUP_TASK_UPDATE = 'backup:task:update',
  BACKUP_TASK_DELETE = 'backup:task:delete',

  BACKUP_CONFIG_RESTORE_READ = 'config-restore:configs:read',
  BACKUP_CONFIG_RESTORE_CREATE = 'config-restore:configs:create',
  BACKUP_CONFIG_RESTORE_UPDATE = 'config-restore:configs:update',
  BACKUP_CONFIG_RESTORE_DELETE = 'config-restore:configs:delete',

  BACKUP_CONFIG_RESET_ACTION_LOGS_READ = 'config-restore:logs:read',
  BACKUP_CONFIG_RESET_ACTION_LOGS_DELETE = 'config-restore:logs:delete',

  BACKUP_LOGS_READ = 'backup:logs:read',
  WEBSITE_MIGRATIONS_READ = 'website:migration:read',

  USAGE_READ = "quotas:read",
  USAGE_WRITE = "quotas:write",
}

export default class RoleRepository implements RoleRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  /**
   * Retrieves all the roles from the API
   * @param {AxiosInstance} axios
   */
  public async getAllRoles(): Promise<RoleInterface[]> {
    const res = await this.axios.get('/auth/roles');
    return res.data;
  }

  public async getAllByDepartment(departmentId: string): Promise<RoleInterface[]> {
    const res = await this.axios.get(`/auth/roles/department/${departmentId}`);

    return res.data;
  }

  public async createRole(data: ApiCreateRoleInterface): Promise<boolean> {
    const res = await this.axios.post('/auth/roles', data);
    return res.status === 201;
  }

  public async getRoleById(roleId: string): Promise<RoleInterface> {
    const res = await this.axios.get(`/auth/roles/${roleId}`);
    return res.data;
  }

  public async updateRole(data: ApiEditRoleInterface): Promise<RoleInterface> {
    const res = await this.axios.patch(`/auth/roles/${data.id}`, data);

    return res.data;
  }

  public async deleteRole(roleId: string): Promise<void> {
    await this.axios.delete('/auth/roles/', { data: { id: roleId } });
  }

  public async changeUsersRole(users: string[], role: string): Promise<void> {
    await this.axios.patch('/auth/roles/users', { users, role });
  }
}
